import React from 'react';
import Icon from '@ant-design/icons';

import SpinnerSvg from './spinner.svg';
import { IconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const SpinnerIcon = (props: IconComponentProps) => <Icon component={SpinnerSvg} {...props} />;
